import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-manage-services',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-services.component.html',
    styleUrl: './manage-services.component.scss'
})
export class ManageServicesComponent {
  newServiceName = '';
  ListingPriority = 0;
  serviceData: any = [];
  exportData: any = [];

  isLoading: boolean = false;
  errorData: boolean = false;
  SaveSuccess: boolean = false;
  constructor(private adminService: AdminService, private commonService: CommonService, private messageService: NotificationService) {
    this.isLoading = true;
    this.setServiceData();
  }
  setServiceData() {
    this.adminService.getAllUserInteractions('ManageService').subscribe((response: any) => {
      this.serviceData = response;
      this.setExportData(response);
      this.processData();
    });
  };

  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      ServiceName: item.ServiceName,
      ServicePriority: item.ServicePriority,
      ServiceRetired: item.ServiceRetired
    }));
  }

  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }

  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

      let payload = {
        "region": "Service",
        "recID": row.RecID,
        "retired": row.ServiceRetired == 'True' ? false : true
      }
      this.adminService.RETIREUSERINTERACTION(payload).subscribe({
        next: (message: any) => {
          this.messageService.showSuccess(message.message);
          this.setServiceData();
        }
      })
    }
  }

  processData() {
    this.serviceData.forEach((service: any) => {
      if (service.ServiceRetired == 'True') {
        service.status = 'Inactive';
        service.buttonName = 'Unretire'
      } else {
        service.status = 'Active';
        service.buttonName = 'Retire'
      }
    });
    this.isLoading = false;

  }

  onInput(event: any): void {
    const input = event.target;
    if (input.value.length > 3) {
      input.value = input.value.slice(0, 3);
      this.ListingPriority = input.value;
    }
  }

  addService() {
    this.errorData = false;
    this.SaveSuccess = false;
    if (this.newServiceName == '' || this.ListingPriority == 0) {
      this.messageService.showError("Please fill all the fields");
      this.errorData = true;
      return;
    }
    let payload = {
      region: "Service",
      data: {
        ServiceName: this.newServiceName,
        ServicePriority: Number (this.ListingPriority),
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }

    this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.messageService.showSuccess(message);
        this.newServiceName = '';
        this.ListingPriority = 0;
        this.setServiceData();
      }
    })

  }

  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-Services.xlsx','TLRAdmin-Services');
    this.messageService.showSuccess("file downloaded successfully");
  }
}
